import React from 'react';

export interface PrinterIconProps {}

export const PrinterIcon: React.FC<PrinterIconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6875 6.00469V0.75H4.3125V6.00469C3.352 6.05392 2.447 6.46985 1.78415 7.16671C1.1213 7.86358 0.751141 8.78824 0.75 9.75V18.75H3.9375V17.25H2.25V9.75C2.25067 9.15347 2.48794 8.58156 2.90975 8.15975C3.33156 7.73794 3.90347 7.50067 4.5 7.5H19.5C20.0965 7.50067 20.6684 7.73794 21.0903 8.15975C21.5121 8.58156 21.7493 9.15347 21.75 9.75V17.25H19.6875V18.75H23.25V9.75C23.2489 8.78824 22.8787 7.86358 22.2158 7.16671C21.553 6.46985 20.648 6.05392 19.6875 6.00469ZM18.1875 6H5.8125V2.25H18.1875V6Z"
        fill="#192033"
      />
      <path d="M18.5625 9.375H20.0625V10.875H18.5625V9.375Z" fill="#192033" />
      <path
        d="M5.4375 12.375H3.5625V13.875H5.4375V23.25H18.1875V13.875H20.0625V12.375H5.4375ZM16.6875 21.75H6.9375V13.875H16.6875V21.75Z"
        fill="#192033"
      />
    </svg>
  );
};
